<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <div
      class="relative popup-background text-white p-8 max-w-5xl w-full mx-4 cursor-pointer"
    >
      <img
        @click="closePopup"
        src="@/assets/images/cross.png"
        class="absolute right-3 top-3 w-10 desktop:w-12"
        alt="close"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from "vue";

const emit = defineEmits(["close"]);
const isOpen = ref(true);

const openPopup = () => {
  isOpen.value = true;
};

const closePopup = () => {
  isOpen.value = false;
  emit("close");
};

defineExpose({
  openPopup,
  closePopup,
});
</script>

<style scoped>
.popup-background {
  background: linear-gradient(180deg, #db0812 40%, #ffde00 100%);
}
</style>
